import React, { useEffect, useState, useContext } from "react";
import PageHeaderV2 from "../../pageheaderV2/PageHeaderV2";
import TableSearchV1 from "../../tableV1/tableSearchV1";
import * as AdminApi from "../../../service/adminApi";
import { CurrentUserContext } from "../../../App";
import { useNavigate, useLocation } from "react-router-dom";
import { RedirectCode400 } from "../../RedirectCode400";
import format from "date-fns/format";

function HistoryLog() {
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [dataHistory, setDataHistory] = useState([]);
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const [sortBy, setSortBy] = useState({ id: "", desc: false });

  const [filters, setFilters] = useState({
    access_date: "",
    role_filter: "",
    detail: "",
    channel: "",
    ip_address: "",
  });

  const optionChannelList = [
    {
      value: "normal_login",
      name: "ด้วยเลขบัตรประชาชน",
    },
    {
      value: "mohpromt_login",
      name: "ด้วยหมอพร้อม",
    },
    {
      value: "thaid_login",
      name: "ด้วย ThaID",
    },
    {
      value: "health_id_login",
      name: "ด้วย Health ID",
    },
    {
      value: "provider_id_login",
      name: "ด้วย Provider ID",
    },
    {
      value: "mobile_app",
      name: "ด้วย Mobile App",
    },
  ];

  const optionRoleList = [
    {
      value: "ADMIN",
      name: "แอดมิน",
    },
    {
      value: "MEDICAL_PERSONNEL",
      name: "แพทย์/เภสัชกร",
    },
    {
      value: "LABORATORY_ADMIN",
      name: "Admin ห้องปฏิบัติการ",
    },
    {
      value: "LABORATORY_PERSONNEL",
      name: "Staff ห้องปฏิบัติการ",
    },
    {
      value: "PATIENT",
      name: "ประชาชน",
    },
    {
      value: "EXECUTIVE",
      name: "ผู้บริหาร",
    },
    {
      value: "HOSPITAL",
      name: "โรงพยาบาล",
    },
    {
      value: "HOSPITAL_PERSONNEL",
      name: "เจ้าหน้าที่โรงพยาบาล",
    },
  ];

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "วันที่",
      accessor: "access_date",
      Cell: ({ row }) => {
        return formatDateThai(row.original.access_date) ?? "";
      },
      Filter: "date",
    },
    {
      Header: "Role",
      accessor: "role_filter",
      Filter: "select",
      DataFilter: optionRoleList,
      Cell: ({ row }) => {
        return row.original.role_name;
      },
    },
    {
      Header: "detail",
      accessor: "detail",
      Filter: "text",
    },
    {
      Header: "Channel",
      accessor: "channel", /// channel_name
      DataFilter: optionChannelList,
      Filter: "select",
      Cell: ({ row }) => {
        return row.original.channel_name;
      },
    },
    {
      Header: "IP Address",
      accessor: "ip_address",
      Filter: "text",
    },
  ];

  const getHistoryLog = async () => {
    setIsLoading(true);
    let res = await AdminApi.getHistoryLog(
      page,
      10,
      filters,
      formatDate(filters.access_date),
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );
    setIsLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDataHistory(res["data"]["user_data_list"]);
        setTotal(res["data"]["amount"]);
        setTotalPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  useEffect(() => {
    getHistoryLog();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [filters, page, sortBy]);

  return (
    <>
      <div className="my-[60px]">
        <PageHeaderV2 titlename={"ประวัติเข้าใช้งาน"} />
        <TableSearchV1
          columns={columns}
          data={dataHistory}
          filters={filters}
          setFilters={setFilters}
          loading={isLoading}
          total={total}
          page={page}
          maxPage={totalPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
      </div>
    </>
  );
}

export default HistoryLog;
